module.exports = __webpack_public_path__ + "static/media/KY.e4bed927.png";